import * as mutation from "./mutations-types";

export default {
  [mutation.UPDATE_CITY_ID](state, cityId) {
    state.cityId = cityId;
  }
};
